const normalisePrefix = (prefix) => (prefix || '').replace(/^_+|_+$/g, '')

const algoliaIndexPrefix = () => {
    const accuvarsPrefix = window.accuvars?.search?.algoliaIndexPrefix
    const mixPrefix = process.env.MIX_ALGOLIA_INDEX_PREFIX

    return normalisePrefix(accuvarsPrefix ?? mixPrefix)
}

const algoliaIndexName = (indexName) => {
    const prefix = algoliaIndexPrefix()

    if (prefix === '') {
        return indexName
    }

    const prefixedIndexName = `${prefix}_${indexName}`

    if (indexName.startsWith(`${prefix}_`)) {
        return indexName
    }

    return prefixedIndexName
}

export default algoliaIndexName
